import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.messaging.chat.messages;

const getMessages = createSelector(getData, messages => messages);

export default getMessages;



// WEBPACK FOOTER //
// ./src/_selectors/messagingSelectors/getMessages.js